import {Injectable, Injector} from '@angular/core';
import {HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse} from '@angular/common/http';
import {Router} from '@angular/router';

import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';

import {AuthenticationService} from './authentication.service';
import {UtilsService} from './utils.service';


@Injectable()
export class TokenInterceptorService implements HttpInterceptor {
    constructor(private injector: Injector, private router: Router, private utilsService: UtilsService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const auth = this.injector.get(AuthenticationService);

        const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));

        return next.handle(req)
            .catch((error: HttpErrorResponse, caught) => {
                if (error.status === 403 && error.error.message === 'User is not authorized to access this resource with an explicit deny') {
                    console.error('Request failed, refreshing access token');
                    this.utilsService.debugLog(currentUser);
                    if (currentUser) {
                        this.utilsService.debugLog('Refreshing Access Token ...');
                        auth.refreshToken();
                        const refreshedUser = JSON.parse(sessionStorage.getItem('currentUser'));
                        req = req.clone({ setHeaders: { Authorization: refreshedUser.refresh_token }});
                        return next.handle(req);
                    }
                    return next.handle(req);
                }
                return Observable.throw(error);
            }
        ) as any;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/token-interceptor.service.ts